import * as React from "react";
import * as _ from 'lodash';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Icons from '../../../icons';
import Select from '../../../components/Select';
import {fetchNotificationData,filterNotificationData,updateNotificationData,changeGroupUpdates,filterGroupByData,
    changeActivityUpdatesStatus, fetchNotificationDetailData, resetNotificationDetail, updateNotificationCount, resetNotification, handleSorting, updateRecentWorkkardGroupNotificationStatus} from '../actions/action';
import { isOnDetailPage } from '../Notification/utils'
import NotificationGroup from './notificationGroup';
import ListingComponent from '../../../components/ListingComponent';
import LoaderComponent from '../../../components/Loader';
import {status as filterStatus} from "./constants";
import CheckBox from "../../../components/Checkbox";
import { getUserInfo } from '../../SpockViewPage/actions/action';
import { setPanelVisibility } from "../../../containers/WorkkardDetail/actions/action";
import { addClass,removeClass } from '../../../common/util';

class Notification extends React.Component {
    constructor(props) {
        super(props);
        this.selectRef = React.createRef();
        this.isOnDetailPage = {
            showGroupedNotificationDetail: false,
            isOnNotificationDetail: isOnDetailPage(),
            allGroupWkdAreRead: false
        }
        this.state = {
            isGroupBy : true
        };
        this.renderNotificationListing = this.renderNotificationListing.bind(this);
        this.onScrollHandler=this.onScrollHandler.bind(this);
        this.changeFilter=this.changeFilter.bind(this);
        this.handleGroupBy=this.handleGroupBy.bind(this);
        this.handleMarkGroupAsRead=this.handleMarkGroupAsRead.bind(this);
        this.handleMarkAllRead=this.handleMarkAllRead.bind(this);
        this.handleActivityUpdatesStatus = this.handleActivityUpdatesStatus.bind(this);
        this.handleOnWorkkardGroupClick=this.handleOnWorkkardGroupClick.bind(this);
        this.handleBackClick=this.handleBackClick.bind(this);
        this.onProfileClick=this.onProfileClick.bind(this);
        this.handleSortBy=this.handleSortBy.bind(this);
    }

    componentDidMount(){
        let body = document.querySelector("body");
        addClass(body, 'au_fixed_right');
        const payload={
            skip:0,
            take: 100,
            _: new Date(),
            sortOrder:'d',
            status: filterStatus.unRead,
            isGroupByEnabled: true,
            isOnNotificationDetail: this.isOnDetailPage.isOnNotificationDetail
        };
        
        if(isOnDetailPage()){
            this.isOnDetailPage.showGroupedNotificationDetail = true
        }         
        this.props.fetchNotificationData(payload);
        this.props.updateNotificationCount(0);
        this.props.setPanelVisibility({
            isNotificationPanelOpen: false
        })
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.notification.panelFilterSettings && nextProps.notification.panelFilterSettings.IsGroupByEnabled != undefined && (nextProps.notification.panelFilterSettings.IsGroupByEnabled != prevState.isGroupBy)){
            return {
                isGroupBy: nextProps.notification.panelFilterSettings.IsGroupByEnabled,
            };
        }
        let unReadNotificationData = 0;
        if (nextProps.notification.panelFilterSettings.IsGroupByEnabled && nextProps.notification.groupingData && nextProps.notification.groupingData.Data && nextProps.notification.groupingData.Data.length > 0){
            unReadNotificationData = nextProps.notification.groupingData.Data.filter(item => item.RecentNotification.Status == filterStatus.unRead || item.RecentNotification.Status == filterStatus.unSeen);
        } else if (!nextProps.notification.panelFilterSettings.IsGroupByEnabled && nextProps.notification.groupingData && nextProps.notification.groupingData.Data && nextProps.notification.groupingData.Data.length > 0) {
            unReadNotificationData = nextProps.notification.groupingData.Data.filter(item => item.Status == filterStatus.unRead || item.Status == filterStatus.unSeen);
        } else if (nextProps.notification.notificationDetail && nextProps.notification.notificationDetail.Data && nextProps.notification.notificationDetail.Data.length > 0){
            unReadNotificationData = nextProps.notification.notificationDetail.Data.filter(item => item.Status == filterStatus.unRead || item.Status == filterStatus.unSeen);
        }
        if (unReadNotificationData.length > 0) {
            return {
                allGroupWkdAreRead: false
            };
        }
        else {
            return {
                allGroupWkdAreRead: true
            };
        }
    }

    componentDidUpdate(prevProps){
        if (!this.isOnDetailPage.showGroupedNotificationDetail && this.props.notification.newNotificationCount > 0 && (prevProps.notification.newNotificationCount != this.props.notification.newNotificationCount) ){
            const payload={
                status: this.props.filter,
                skip:0,
                take: 100,
                sortOrder:'d',
                isOnNotificationDetail: this.isOnDetailPage.isOnNotificationDetail,
                _: new Date(),
            };
                 
            this.props.fetchNotificationData(payload); 
        }
    }

    componentWillUnmount(){
        this.props.updateRecentWorkkardGroupNotificationStatus();
        this.props.resetNotification();
        this.props.setPanelVisibility({
            isNotificationPanelOpen: false
        })
        removeClass(document.querySelector("body"), 'au_fixed_right');
        removeClass(document.querySelector("body"), 'openNotification');
        this.props.onClose();
    }

    renderNotificationListing(notification) {
        if (notification.Data && notification.Data.length > 0) {
        const isGroupByEnabled = this.props.notification.panelFilterSettings && this.props.notification.panelFilterSettings.IsGroupByEnabled != undefined ? this.props.notification.panelFilterSettings.IsGroupByEnabled : this.state.isGroupBy;
        const {Data}=notification;
        const notificationIds = Data.map(item=>{
            let date = (isGroupByEnabled && item.RecentNotification) ? item.RecentNotification.CreatedDate : item.CreatedDate;
            date = date.split('at');
            return {id:item.Id, date:date[0], time:date[1], data: item}
        });
        const groupNotificationIds = _.groupBy(notificationIds, 'date');
        const prop = {
            data:Object.keys(groupNotificationIds).map(key=>({key,data:groupNotificationIds[key]})),
            cellTemplate: NotificationGroup,
            onScrollHandler: this.onScrollHandler,
            onItemClick: () => false,
            onCellClick: (data) => { isGroupByEnabled ? this.handleOnWorkkardGroupClick(data): false},
            type:"div",
            selectedId: '',
            classname:'notification scrollArea' + (this.isOnDetailPage.showGroupedNotificationDetail ? ' detailHeader' : ''),
            extraData: {
                handleMarkRead: (isGroupByEnabled && !this.isOnDetailPage.showGroupedNotificationDetail) ? this.handleMarkGroupAsRead : this.handleActivityUpdatesStatus,
                IsGroupByEnabled: isGroupByEnabled,
                showGroupedNotificationDetail: this.isOnDetailPage.showGroupedNotificationDetail,
                onProfileClick:this.onProfileClick,
                key:'RecentNotification',
                newNotificationCounter: this.props.notification.newNotificationCount,
                displayMarkReadIcon:true,
                displayProfilePic:true,
                displayTriggerByName :true
            }
        }
        return (
            <ListingComponent {...prop}/>
        );
    }
        else if(!this.props.notification.isLoading) {
            return <div className="noDataFound">No Notification available.</div>;
        }
    }

    getNotificationDetailWorkkardId(){
        const workkardId = this.props.notification.notificationDetail?.Data?.[0]?.WorkkardId;
        return workkardId != null ? workkardId : this.props.workkardDetail?.Id;
    }

    getNotificationDetailWorkkardNo(){
        const workkardNo = this.props.notification.notificationDetail?.Data?.[0]?.WorkkardNo;
        return workkardNo != null ? workkardNo : this.props.workkardDetail?.WorkkardNumber;
    }

    onProfileClick(e,id,type){
        e.stopPropagation();        
        const targetRect = e.currentTarget.getBoundingClientRect();
        const payload = {
          target: targetRect,
          userId: id, 
          type: type,
          position: 'left'
        }
        this.props.getUserInfo(payload);
      }

    onScrollHandler(){
        let payload; 

        if (this.isOnDetailPage.isOnNotificationDetail){
            payload={
                wkId: this.getNotificationDetailWorkkardId() || 0,
                lasthistoryId:this.props.notification.notificationDetail.Data[this.props.notification.notificationDetail.Data.length-1]?.Id ,
                status: this.props.filter,
                take: 10,
                sortOrder:'d',
                isOnNotificationDetail: this.isOnDetailPage.isOnNotificationDetail,
                _: new Date(),
            }
        }
        else{
            payload={
                lasthistoryId: (this.state.isGroupBy ? 
                                this.props.notification.groupingData.Data[this.props.notification.groupingData.Data.length-1].RecentNotification.Id 
                                 : this.props.notification.groupingData.Data[this.props.notification.groupingData.Data.length-1].Id), 
                status: this.props.filter,
                isGroupByEnabled: this.state.isGroupBy,
                sortOrder:'d',
                isOnNotificationDetail: this.isOnDetailPage.isOnNotificationDetail,
                _: new Date()
            }
        }
        this.props.updateNotificationData(payload);
    }

    handleOnWorkkardGroupClick(data){
        this.isOnDetailPage.showGroupedNotificationDetail = true
        this.isOnDetailPage.isOnNotificationDetail = true
        
        const payload = {
            wkId: data.WorkkardId || 0,
            status: this.props.filter,
            sortOrder:'d',
            take: 50,
            _: new Date()
        }
        this.props.fetchNotificationDetailData(payload);
        this.props.updateNotificationCount(0);
        this.props.updateRecentWorkkardGroupNotificationStatus();
    }

    changeFilter(value){
        const payload={
            status: value,
            skip:0,
            take: 100,
            _: new Date(),
            sortOrder:'d',
            isOnNotificationDetail: this.isOnDetailPage.isOnNotificationDetail
        };
        this.props.filterNotificationData(payload);
    }

    handleGroupBy(event){
        const {filter}=this.props;
        this.selectRef.current.closeDropDown();
        const payload={
            lasthistoryId: 0,
            status: filter,
            skip: 0,
            take: 100,
            sortOrder:'d',
            isGroupByEnabled: !event.checked,
            isOnNotificationDetail: this.isOnDetailPage.isOnNotificationDetail
        };
        this.props.filterGroupByData(payload);
        if (filter != filterStatus.read){
            this.props.updateNotificationCount(0);
        }
    }

    handleMarkGroupAsRead(data,status){
        const payload={
            wkId: data.WorkkardId != null ?  data.WorkkardId : 0,
            status:status,
            Id:data.Id
        }
        this.props.changeGroupUpdates(payload);
        this.props.updateRecentWorkkardGroupNotificationStatus();
    }

    handleActivityUpdatesStatus(data,status,reset){
        reset = reset ? reset : false;
        const payload={
            resetCounter: reset,
            activityUpdateIds: data.Id,
            status: status,
            Id:data.Id
        }
        this.props.changeActivityUpdatesStatus(payload);
        if (!this.state.isGroupBy && !this.isOnDetailPage.showGroupedNotificationDetail){
            this.props.updateNotificationCount(0);
        }
    }

    handleMarkAllRead(){
        let payload={};
        if (!this.isOnDetailPage.isOnNotificationDetail)
        {
            payload={
                wkId: 0,
                status: filterStatus.read,
                resetAllCounters: true,
                allUpdates: true,
                markAllAsRead:true
            }
        }
        else{
            payload={
                wkId: this.getNotificationDetailWorkkardId(),
                status: this.state.allGroupWkdAreRead ? filterStatus.unRead : filterStatus.read,
                markAllAsRead:false
            }
        }
        this.props.changeGroupUpdates(payload);
        this.props.updateRecentWorkkardGroupNotificationStatus();
        this.props.updateNotificationCount(0);
    }

    handleBackClick(){
        this.isOnDetailPage.showGroupedNotificationDetail = false
        this.isOnDetailPage.isOnNotificationDetail = false
        this.props.resetNotificationDetail();
        const payload={
            status: this.props.filter,
            skip:0,
            take: 100,
            sortOrder:'d',
            _: new Date(),
            isOnNotificationDetail: false,
            skipStatusUpdate: true
        };
        this.props.fetchNotificationData(payload);
    }

    handleSortBy(){
        const payload = {
            wkId: this.getNotificationDetailWorkkardId() || 0,
            status: this.props.filter,
            skip:0,
            take: 50,
            sortOrder:(this.isOnDetailPage.isOnNotificationDetail ? this.props.notification.notificationDetail.sortOrder : this.props.notification.groupingData.sortOrder) == 'a' ? 'd':'a',
            isGroupByEnabled:this.props.notification.panelFilterSettings.IsGroupByEnabled,
            _: new Date(),
            isOnNotificationDetail: this.isOnDetailPage.isOnNotificationDetail
        }
        this.props.handleSorting(payload);
    }

    render() {
        const {filter}=this.props;
        const selectOptions= [
            { label: "All", value: filterStatus.all },
            { label: "Read", value: filterStatus.read },
            { label: "Unread", value: filterStatus.unRead },
        ];
        let disable = true;
        if( this.isOnDetailPage.showGroupedNotificationDetail ){
            disable = !(Object.keys(this.props.notification.notificationDetail).length > 0 && this.props.notification.notificationDetail.Data.length > 0);
        } else if (Object.keys(this.props.notification.groupingData).length > 0 && this.props.notification.groupingData.Data && this.props.notification.groupingData.Data.length > 0){
            if (!this.state.allGroupWkdAreRead && (filter == filterStatus.all || filter == filterStatus.unRead)){
                disable = false
            }
        }
        
        return (
            <React.Fragment>
                {
                    this.props.notification.isLoading && <LoaderComponent />
                }
                <div className="notificationMain">
                    { this.isOnDetailPage.showGroupedNotificationDetail && this.props.notification.newNotificationCount > 0 && <div className="newNotificationMsg">
                        You have {this.props.notification.newNotificationCount} new notifications
                    </div>}
                    <header className="rowFlex rowSpaceBetween" style={{ 'paddingTop': (this.isOnDetailPage.showGroupedNotificationDetail && this.props.notification.newNotificationCount > 0) ? "10px" : "0px" }}>
                        {
                            this.isOnDetailPage.showGroupedNotificationDetail &&
                            <div className="rowFlex alignMiddle backGroupCard">
                                <a className="alignMiddle backArrow" href="javascript:void(0)" onClick={() => { this.handleBackClick() }}><Icons name="chev" className="icon arrow" />{this.props.notification.newNotificationCount > 0 && <span className="newCardNotification"></span>}</a>
                                {this.props.notification.notificationDetail && <div className="ml rwoFlex alignMiddle wkNumber">
                                        <label className="badges wkSymbol mr__1">{this.getNotificationDetailWorkkardId()?'W':'0'}</label> {this.getNotificationDetailWorkkardNo()?this.getNotificationDetailWorkkardNo():'Others'}
                                    </div>
                                }
                            </div>
                        }
                        {!this.isOnDetailPage.showGroupedNotificationDetail && <h1 className="rowFlex alignMiddle">Notifications {!this.state.isGroupBy && this.props.notification.newNotificationCount > 0 && <label className="newCard ml">{this.props.notification.newNotificationCount} new</label>}</h1>}
                        <a href="javascript:void(0)" onClick={this.props.onClose}><Icons name="close" className="icon" /></a>
                    </header>
                    <div className="filterBlock">
                        <div className="filterLeft ml">
                            <Select
                                ref={this.selectRef}
                                options={selectOptions}
                                selected={filter||filterStatus.unRead}
                                onSelect={(value) => this.changeFilter(value)}
                                openOnClick={true}
                                iconName="downArrow"
                                styleClass="ml"
                                isOpenRight={false}
                                template={!this.isOnDetailPage.showGroupedNotificationDetail && <a><div className="flexGrow">
                                    <CheckBox item={{id:"byWorkkards", checked:this.state.isGroupBy, label:"by Workkards"}} handleCheckbox={(event) => this.handleGroupBy(event)} />
                                </div></a>}
                            />
                        </div>
                        {
                        <div className="filterRight mr">
                            <ul className="rowFlex alignMiddle">
                                <li className="">
                                    <a className={disable ? 'disabled' : ''}href="javascript:void(0)" onClick={()=>{this.handleMarkAllRead() }}>
                                        {
                                            this.isOnDetailPage.showGroupedNotificationDetail ?
                                            <React.Fragment>
                                                {
                                                    filter == filterStatus.all ?
                                                    (
                                                        this.state.allGroupWkdAreRead ?
                                                        <>mark all as unread</>
                                                        :
                                                        <>mark all as read</>
                                                    ):
                                                        filter == filterStatus.unRead ? <>mark all as read</> : <>mark all as unread</>
                                                }
                                            </React.Fragment>
                                            :
                                            <>mark all as read</>
                                        }                                                    
                                    </a>
                                </li>
                                {
                                    (this.isOnDetailPage.showGroupedNotificationDetail) &&
                                    <li onClick={()=>this.handleSortBy()} className="quickTooltip-bottom" data-quicktooltip ={this.props.notification.notificationDetail.sortOrder == 'a' ? 'Sort by descending order':'Sort by ascending order'}>
                                        <span className="iconRipple">
                                            <Icons name="sort" className="icon" />
                                        </span>
                                    </li>
                                }
                            </ul>
                        </div>
                        }
                    </div>
                    {
                        (this.isOnDetailPage.showGroupedNotificationDetail) ?
                            Object.keys(this.props.notification.notificationDetail).length > 0 && this.props.notification.notificationDetail.Data ?
                                this.renderNotificationListing(this.props.notification.notificationDetail)
                                :
                                null
                            :
                            (
                                Object.keys(this.props.notification.groupingData).length > 0 && this.props.notification.groupingData.Data ?
                                this.renderNotificationListing(this.props.notification.groupingData)
                                    :
                                   null
                            )
                    }
                </div>
            </React.Fragment>
        )
    }
}
const mapStateToProps = (state) => ({
    notification : state.header.notification,
    filter:state.header.notification.filter.filterStatus,
    workkardDetail: state.workkardDetail.workkardDetail,
});

const mapDispatchToProps = (dispatch) => ({
    fetchNotificationData:bindActionCreators(fetchNotificationData,dispatch),
    filterNotificationData:bindActionCreators(filterNotificationData,dispatch),
    updateNotificationData:bindActionCreators(updateNotificationData,dispatch),
    changeGroupUpdates:bindActionCreators(changeGroupUpdates,dispatch),
    filterGroupByData:bindActionCreators(filterGroupByData,dispatch),
    changeActivityUpdatesStatus:bindActionCreators(changeActivityUpdatesStatus,dispatch),
    fetchNotificationDetailData:bindActionCreators(fetchNotificationDetailData,dispatch),
    resetNotificationDetail:bindActionCreators(resetNotificationDetail,dispatch),
    getUserInfo  : bindActionCreators(getUserInfo, dispatch),
    updateNotificationCount: bindActionCreators(updateNotificationCount, dispatch),
    resetNotification:bindActionCreators(resetNotification,dispatch),
    handleSorting:bindActionCreators(handleSorting,dispatch),
    updateRecentWorkkardGroupNotificationStatus: bindActionCreators(updateRecentWorkkardGroupNotificationStatus,dispatch),
    setPanelVisibility: bindActionCreators(setPanelVisibility, dispatch)
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Notification);